export const WORKSHEET_LOAN_FACTS_TITLE = 'Loan facts';

export const WORKSHEET_LOAN_FACTS_SUBTITLE = 'From the loan — read-only';

export const WORKSHEET_LOAN_FACTS_SECTION_TITLE = {
  BORROWER: 'Borrower',
  CO_BORROWER: 'Co-Borrower',
  LOAN: 'Loan Terms',
  HOME: 'Home',
  LOCATION: 'Location',
  INSURANCE: 'Insurance',
};

export const WORKSHEET_LOAN_FACTS_LABEL = {
  NAME: 'Name',
  DATE_OF_BIRTH: 'Date of Birth',
  SSN: 'SSN',
  HOME_PHONE: 'Home Phone',
  CELL_PHONE: 'Cell Phone',
  EMAIL: 'Email',
  CURRENT_ADDRESS: 'Current Address',
  MAILING_ADDRESS: 'Mailing Address',
  LOAN_AMOUNT: 'Loan Amount',
  INTEREST_RATE: 'Interest Rate',
  TERM: 'Term',
  MONTHLY_PAYMENT: 'Monthly P&I Payment',
  DOWN_PAYMENT: 'Down Payment',
  HOME_SIZE: 'Size (W × L)',
  PROPERTY_ADDRESS: 'Property Address',
  MONTHLY_HOMEOWNERS_INSURANCE: 'Homeowners Insurance (monthly)',
};

export const WORKSHEET_LOAN_FACTS_SSN_VISIBLE_DIGITS = 4;

export const WORKSHEET_LOAN_FACTS_MAILING_SAME_AS_CURRENT = 'Same as current address';
